<template>
	<div>
		<header class="page-title">
			<h2>Recommended Articles - {{data.name}}</h2>
			<div class="ml-auto">
				<a @click="addArticle" class="btn btn-md btn-success"><i class="fas fa-plus"></i> New Article</a>
			</div>
		</header>
		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th>Article No.</th>
						<th>Article Title</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="n in this.data.settings.recommendedArticles.number">
						<td>Article {{n}}</td>
						<td>
							<select @change="saveRecommendedArticles" id="article-list-1" v-model="recommendedArticles[n-1]">
								<option :value="article.id" v-for="(article,index) in articles">{{article.title}}</option>
							</select>
						</td>
						<td>
							<a @click="deleteRecommendedArticle(n-1)" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import modal from '../../Modal/DefaultModal.vue';
	import VueSelect from '../../../../../node_modules/vue-select';

	export default {
		props: {
			data: {
				type: Object
			},
		},
		components: {
			modal,
			"vue-select": VueSelect,
		},
		data() {
			return {

				id: this.data.id,

				articles: this.data.articles,
				recommendedArticles: this.data.settings.recommendedArticles.ids ? this.data.settings.recommendedArticles.ids : {},

			}
		},
		methods: {
			saveRecommendedArticles: function () {
				let vm = this;

				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/saverecommendedarticles',
					{
						id: vm.id,
						recommendedArticles: vm.recommendedArticles
					},
				).then(function (response) {
					vm.$toastr.success('Content saved successfully.');
				}).catch(function (e) {
					vm.$toastr.error('Content saving failed.', 'Error');
					vm.errors.record(e.response.data);
				});

			},
			addArticle: function () {
				this.data.settings.recommendedArticles.number++;
				this.$forceUpdate();
			},
			deleteRecommendedArticle: function (index) {
				let vm = this;
				var articleId = this.recommendedArticles[index];
				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + vm.id + '/deleterecommendedarticle',
					{
						articleId: articleId,
					},
				).then(function (response) {
					vm.$toastr.success('Content saved successfully.');
					location.reload();
				}).catch(function (e) {
					vm.$toastr.error('Content saving failed.', 'Error');
					vm.errors.record(e.response.data);
				});
			}
		}
	}
</script>

